export const APPROVED_VENDORS = "20260721_approved_vendors"
export const SQUAWK_CARD = "20260916-squawk-card"
export const CREATE_QUOTE_TASK_FROM_SQUAWK =
  "20261006-create-quote-task-from-squawk"
export const DASHBOARD_AIRCRAFT = "20261008-dashboard-aircraft"
export const DASHBOARD_QUOTE = "20261008-dashboard-quote"
export const WO_PAGES = "20261012-wo-pages"
export const REPORT_TEMPLATE = "20261020-report-template"
export const DICTATION = "20261022-dictation"
export const PURCHASE_ORDERS = "20261026-purchase-orders"
export const PLANNING = "20261027-planning"
export const SALESFORCE = "20261028-salesforce"
